<template>
  <component
    :is="comp.is"
    v-bind="comp.bind"
    class="relative flex min-h-[42px] items-center rounded-lg border px-4 py-2 font-normal transition focus:outline-none focus:ring-4 focus:ring-blue-300"
    :class="{
      'cursor-not-allowed opacity-50': isDisabled && !isProcessing,
      'hover:bg-opacity-80': !isProcessing && !isDisabled,
      'cursor-wait': isProcessing,
    }"
    :disabled="isProcessing || isDisabled"
    @click.native="handleClick"
  >
    <span
      class="inline-flex items-center gap-x-2"
      :class="{ invisible: isProcessing }"
    >
      <slot name="icon" />
      <slot />
    </span>

    <template v-if="isProcessing">
      <UpmSpinner
        class="absolute left-1/2 top-1/2 -ml-[10px] -mt-[10px] h-5 w-5 text-current"
      />
    </template>
  </component>
</template>

<script setup lang="ts">
import UpmSpinner from "@src/components/UpmSpinner.vue";
import { useAttrs, computed, toRefs, defineComponent } from "vue";

const attrs = useAttrs();

const props = withDefaults(
  defineProps<{
    as?: "button" | "anchor";
    isProcessing?: boolean;
  }>(),
  {
    as: "button",
    isProcessing: false,
  }
);

const { isProcessing } = toRefs(props);

const isDisabled = computed(() => {
  if (typeof attrs.disabled === "boolean") return attrs.disabled;
  return attrs.hasOwnProperty("disabled");
});

const comp = computed(() => {
  switch (props.as) {
    case "anchor":
      return {
        is: "a",
      };
    case "button":
    default:
      return {
        is: "button",
        bind: {
          type: "button",
        },
      };
  }
});

function handleClick($event: Event) {
  if (isProcessing.value) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
    return;
  }
}
</script>
